import React from "react";
// @ts-ignore
import { CirclesWithBar } from 'react-loader-spinner'

const Indicator = ({ width = "100", height = "100" }: { width?: string, height?: string }) => <CirclesWithBar
  height={height}
  width={width}
  color="#4fa94d"
  wrapperStyle={{}}
  wrapperClass="mt-2 mb-5"
  visible={true}
  outerCircleColor=""
  innerCircleColor=""
  barColor=""
  ariaLabel='circles-with-bar-loading'
/>

export const Loading = ({ full, width, height }: { full?: boolean, width?: string, height?: string }) => full ?
  <div className="fixed z-50 left-0 top-0 w-full h-full bg-white bg-opacity-50 flex justify-center items-center"><Indicator /></div>
  : <Indicator width={width} height={height} />
